// extracted by mini-css-extract-plugin
export default {"container":"SecondaryContactCard_container__fDKD4","name":"SecondaryContactCard_name__yZMdr"};